import React, { Fragment } from "react";
import ContainerDimensions from "react-container-dimensions";
import GroupBarchart from "../../../../d3Components/NewBarchart/GroupBarchart";
import Legend from "../../../../d3Components/legend";
import SimpleTable from "../../common/simpleTable";
import WithCard from "../../../../common/withCard";

const Annualized = ({
  typeName,
  benchmark_name,
  display_orig_portfolio,
  model_name,
  annuaized_yearly_data,
}) => {
  return (
    <WithCard>
      <h4 className="text-uppercase bold">
        ANNUALIZED BACK-TESTED PERFORMANCE
      </h4>

      <Fragment>
        {annuaized_yearly_data.length > 0 ? (
          <Fragment>
            <div style={{ overflowX: "auto" }}>
              <ContainerDimensions>
                {({ width }) => (
                  <Fragment>
                    <Legend
                      height={30}
                      width={width}
                      legend1={
                        display_orig_portfolio
                          ? `IQCIO Model ${model_name ? "+" : ""}`
                          : "Portfolio"
                      }
                      legend2={
                        display_orig_portfolio ? "Benchmark *" : typeName
                      }
                      legend3={
                        display_orig_portfolio ? "Original Portfolio" : null
                      }
                    />
                    {width > 0 ? (
                      <GroupBarchart
                        containerWidth={width}
                        height={300}
                        data={annuaized_yearly_data}
                        targetDiv="backtestBarChart5"
                      />
                    ) : null}
                  </Fragment>
                )}
              </ContainerDimensions>
            </div>
          </Fragment>
        ) : null}
        <SimpleTable
          rowHead1={
            display_orig_portfolio
              ? `IQCIO Model ${model_name ? "+" : ""}`
              : "Portfolio"
          }
          rowHead2={display_orig_portfolio ? "Benchmark *" : "Benchmark"}
          rowHead3={display_orig_portfolio ? "Original Portfolio" : null}
          heading={annuaized_yearly_data.map((d, i) => {
            return <td key={i}>{d.metric_name}</td>;
          })}
          Row1={annuaized_yearly_data.map((d, i) => {
            return (
              <td key={`${d.portfolio}-${i}`}>{`${d.portfolio.toFixed(
                2
              )} %`}</td>
            );
          })}
          Row2={annuaized_yearly_data.map((d, i) => {
            return (
              <td key={`${d.benchmark}-${i}`}>{`${d.benchmark.toFixed(
                2
              )} %`}</td>
            );
          })}
          Row3={annuaized_yearly_data.map((d, i) => {
            return d["Original portfolio"] ? (
              <td key={`${d["Original portfolio"]}-${i}`}>{`${d[
                "Original portfolio"
              ].toFixed(2)} %`}</td>
            ) : null;
          })}
        />
        {display_orig_portfolio && benchmark_name ? (
          <div>
            <small>
              <b>*</b>&nbsp;{benchmark_name}
            </small>
          </div>
        ) : null}
        {model_name ? (
          <div>
            <small>
              <b>+</b>&nbsp;{model_name}
            </small>
          </div>
        ) : null}
      </Fragment>
    </WithCard>
  );
};

export default Annualized;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/yearlyPerformance/annualized.jsx